export default "__VITE_ASSET__87170b11__"